<section class="playground">
  <h2 class="playground__heading">Image preview + icon action</h2>
  <p class="playground__hint">
    <code>common-image-preview-icon-action</code> — <code>size="small"</code> (172×172) o
    <code>size="large"</code> (ancho 100% del padre, cuadrado). Incluye botón arriba-derecha y salida <code>(action)</code>.
  </p>

  <div class="playground__grid">
    <div class="playground__controls">
      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="disabled" />
        <span>disabled</span>
      </label>
      <button type="button" class="playground__btn" (click)="clearPreview()">Quitar imagen (empty)</button>
    </div>

    <div class="playground__preview">
      <p class="playground__preview-title">Preview</p>
      <div class="playground__preview-box">
        <div class="playground__preview-stack">
          <div>
            <p class="playground__variant">small</p>
            <common-image-preview-icon-action
              size="small"
              [imageUrl]="imageUrl"
              alt="Vista previa de ejemplo"
              [disabled]="disabled"
              actionAriaLabel="Acción"
              (action)="onAction()"
            ></common-image-preview-icon-action>
          </div>

          <div class="playground__large-wrapper">
            <p class="playground__variant">large (ancho del contenedor)</p>
            <common-image-preview-icon-action
              size="large"
              [imageUrl]="imageUrl"
              alt="Vista previa de ejemplo"
              [disabled]="disabled"
              actionAriaLabel="Acción"
              (action)="onAction()"
            ></common-image-preview-icon-action>
          </div>
        </div>
      </div>
      <p *ngIf="lastEvent" class="playground__meta">{{ lastEvent }}</p>
    </div>
  </div>
</section>
